import {
    LOGIN_USER,
    LOGIN_SUCCESS,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    API_ERROR,
    CHANGE_PASSWORD,
  } from './actionTypes';
  
  const initialState = {
    error: "",
    loading: false,
    user: (() => {
      try {
        const storedUser = localStorage.getItem("userInfo");
        return storedUser ? JSON.parse(storedUser) : null;
      } catch (e) {
        console.error("Error parsing userInfo from localStorage", e);
        return null;
      }
    })(),
  };
  
  const login = (state = initialState, action) => {
    switch (action.type) {
      case LOGIN_USER:
        return {
          ...state,
          loading: true,
        };
  
      case LOGIN_SUCCESS:
        return {
          ...state,
          user: action.payload,
          loading: false,
        };
  
      case CHANGE_PASSWORD:
        return {
          ...state,
          changePassword: action.payload,
        };
  
      case LOGOUT_USER:
        return {
          ...state,
          user: null,
        };
  
      case LOGOUT_USER_SUCCESS:
        return {
          ...state,
        };
  
      case API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false,
        };
  
      default:
        return state;
    }
  };
  
  export default login;
  